/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconLocationOn/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconLocationOn({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconLocationOn",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
let fill2OrdtColorsBlack1 = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconLocationOn.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z7bSU1': alignSelf,'--mt-2-Z7bSU1': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z7bSU1': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z7bSU1': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z7bSU1': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z7bSU1': opacity,'--w-10-Z7bSU1': typeof width === 'number' ? `${width}px` : width,'--h-11-Z7bSU1': typeof height === 'number' ? `${height}px` : height,'--a-7-Z7bSU1': isAnimated ? animation : "none",'--sd-8-Z7bSU1': isAnimated ? strokeDashoffset : 0,'--sd-9-Z7bSU1': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconLocationOn.SvgPath"
  data-view-path={viewPath}
 d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
 style={{'--f-12-Z7bSU1': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconLocationOn.SvgPath:1"
  data-view-path={viewPath}
 d="M12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
 style={{'--f-12-Z7bSU1': fill2OrdtColorsBlack1}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}